import React from 'react';
import cn from 'classnames';

import Button from 'components/UI/Button';
import Icon from 'components/UI/Icon';
import { FormField, FormCheckbox } from 'components/Forms';
import { useTrans } from 'utils/localisation';

import * as styles from './FormSubmit.module.scss';

export const FormSubmit = ({
  className,
  size = 'md',
  title = 'Send',
  fullWidthMobile = true,
  disabled,
  nda,
  displaySubmitButton = true,
}) => {
  const t = useTrans(['corporateForm']);
  return (
    <div className={cn(styles.submit, !displaySubmitButton && styles.withoutButton, className)}>
      {nda && <FormField className={styles.ndaWrapper} Component={FormCheckbox} {...nda} />}
      <div className={styles.buttonWrap}>
        {displaySubmitButton && (
          <Button type="submit" size={size} fullWidthMobile={fullWidthMobile} disabled={disabled}>
            {title}
          </Button>
        )}
        <div className={styles.privacyWrap}>
          <Icon name="protected-privacy" className={styles.privacyIcon} />
          <p className={styles.privacyText}>{t('protectedPrivacy')}</p>
        </div>
      </div>
    </div>
  );
};
